import { render, staticRenderFns } from "./SupplierInventory.vue?vue&type=template&id=85cbd828"
import script from "./SupplierInventory.vue?vue&type=script&lang=js"
export * from "./SupplierInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports